import React from 'react';
import PropTypes from 'prop-types';
import { formatterMoney } from 'utils/format';
import { Card } from 'ui-components/Card'
import { LineInfo } from 'ui-components/LineInfo';

export default function Sales({ sales }) {
  return (
    <Card>
      <h5>Vendas</h5>
      <LineInfo
        label="Total de pedidos pagos"
        value={formatterMoney(sales.attributes.total_paid)}
      />

      <LineInfo
        label="Pedidos em aberto"
        value={formatterMoney(sales.attributes.total_pending)}
      />

      <LineInfo
        label="Pedidos fechados e não pagos"
        value={formatterMoney(sales.attributes.total_pending)}
      />
    </Card>
  )
}

Sales.propTypes = {
  sales: PropTypes.objectOf(PropTypes.any).isRequired,
}
